import { Component } from '@angular/core';

import { Register, ToolService } from '../../shared';


@Register({
  name: 'catalog',
  title: 'igo.catalog',
  icon: 'photo_library'
})
@Component({
  selector: 'igo-catalog-tool',
  template: require('./catalog-tool.component.html'),
  styles: [require('./catalog-tool.component.styl')]
})
export class CatalogToolComponent {

  constructor(private toolService: ToolService) {}

  handleFeatureSelect() {
    const tool = this.toolService.getTool('catalogLayers');
    if (tool) {
      this.toolService.selectTool(tool);
    }
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/catalog-tool/catalog-tool.component.ts